<template>
  <div>
    <div class="overflow-hidden flex justify-center">
      <div>
        <div class="head m-b-6">
          <h2 style="margin-bottom: 13px">تغییر گذرواژه</h2>
          <p>با دقت کامل فرمائید</p>
        </div>
        <div class="items-center m-b-2">
          <div class="mx-auto max-w-screen-xl m-b-126">
            <input
              type="password"
              class="pass-input"
              v-model="password"
              v-if="!showPass"
              placeholder=" گذرواژه فعلی"
            />
            <input
              class="pass-input"
              v-model="password"
              v-if="showPass"
              placeholder="گذرواژه فعلی"
            />
            <img
              src="@/assets/icons8-eye-26.png"
              @click="showPassHandler"
              class="pass-eye"
            />

            <input
              type="password"
              class="pass-input"
              v-model="rpassword"
              v-if="!showrPass"
              placeholder="گذرواژه جدید"
            />
            <input
              class="pass-input"
              v-model="rpassword"
              v-if="showrPass"
              placeholder="گذر واژه جدید"
            />
            <img
              src="@/assets/icons8-eye-26.png"
              @click="showrPassHandler"
              class="pass-eye"
            />
          </div>
        </div>
        <button class="m-btn" @click="savePassrHandler">تایید</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPass: false,
      showrPass: false,
      password: null,
      rpassword: null,
      rulse: false,
    };
  },
  methods: {
    showPassHandler() {
      this.showPass = !this.showPass;
    },
    showrPassHandler() {
      this.showrPass = !this.showrPass;
    },
    hash() {
      var hash = 0,
        i,
        chr;
      if (this.length === 0) return hash;
      for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    savePassrHandler() {
      if (this.password == this.rpassword) {
        var pass = this.hash(this.password);
        window.localStorage.setItem("pass", pass);
      }
    },
  },
};
</script>
